module.exports = __webpack_public_path__ + "img/snowfall.3da50727.png";